/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import _head from "lodash/head";
import { VAT_MULTIPLIER } from "./globalVars";

class FeesService {
  static rvgFees = [
    { value: 500, fee: 51.5 },
    { value: 1000, fee: 93 },
    { value: 1500, fee: 134.5 },
    { value: 2000, fee: 176 },
    { value: 3000, fee: 235.5 },
    { value: 4000, fee: 295 },
    { value: 5000, fee: 354.5 },
    { value: 6000, fee: 414 },
    { value: 7000, fee: 473.5 },
    { value: 8000, fee: 533 },
    { value: 9000, fee: 592.5 },
    { value: 10000, fee: 652 },
    { value: 13000, fee: 707 },
    { value: 16000, fee: 762 },
    { value: 19000, fee: 817 },
    { value: 22000, fee: 872 },
    { value: 25000, fee: 927 },
    { value: 30000, fee: 1013 },
    { value: 35000, fee: 1099 },
    { value: 40000, fee: 1185 },
    { value: 45000, fee: 1271 },
    { value: 50000, fee: 1357 },
    { value: 65000, fee: 1456.5 },
    { value: 80000, fee: 1556 },
    { value: 95000, fee: 1655.5 },
    { value: 110000, fee: 1755 },
    { value: 125000, fee: 1854.5 },
    { value: 140000, fee: 1954 },
    { value: 155000, fee: 2053.5 },
    { value: 170000, fee: 2153 },
    { value: 185000, fee: 2252.5 },
    { value: 200000, fee: 2352 },
    { value: 230000, fee: 2492 },
    { value: 260000, fee: 2632 },
    { value: 290000, fee: 2772 },
    { value: 320000, fee: 2912 },
    { value: 350000, fee: 3052 },
    { value: 380000, fee: 3192 },
    { value: 410000, fee: 3332 },
    { value: 440000, fee: 3472 },
    { value: 470000, fee: 3612 },
    { value: 500000, fee: 3752 },
  ];

  static rvgFeesUntil30052025 = [
    { value: 500, fee: 49 },
    { value: 1000, fee: 88 },
    { value: 1500, fee: 127 },
    { value: 2000, fee: 166 },
    { value: 3000, fee: 222 },
    { value: 4000, fee: 278 },
    { value: 5000, fee: 334 },
    { value: 6000, fee: 390 },
    { value: 7000, fee: 446 },
    { value: 8000, fee: 502 },
    { value: 9000, fee: 558 },
    { value: 10000, fee: 614 },
    { value: 13000, fee: 666 },
    { value: 16000, fee: 718 },
    { value: 19000, fee: 770 },
    { value: 22000, fee: 822 },
    { value: 25000, fee: 874 },
    { value: 30000, fee: 955 },
    { value: 35000, fee: 1036 },
    { value: 40000, fee: 1117 },
    { value: 45000, fee: 1198 },
    { value: 50000, fee: 1279 },
    { value: 65000, fee: 1373 },
    { value: 80000, fee: 1467 },
    { value: 95000, fee: 1561 },
    { value: 110000, fee: 1655 },
    { value: 125000, fee: 1749 },
    { value: 140000, fee: 1843 },
    { value: 155000, fee: 1937 },
    { value: 170000, fee: 2031 },
    { value: 185000, fee: 2125 },
    { value: 200000, fee: 2219 },
    { value: 230000, fee: 2351 },
    { value: 260000, fee: 2483 },
    { value: 290000, fee: 2615 },
    { value: 320000, fee: 2747 },
    { value: 350000, fee: 2879 },
    { value: 380000, fee: 3011 },
    { value: 410000, fee: 3143 },
    { value: 440000, fee: 3275 },
    { value: 470000, fee: 3407 },
    { value: 500000, fee: 3539 },
  ];

  static gkgFees = [
    { value: 500, fee: 35 },
    { value: 1000, fee: 53 },
    { value: 1500, fee: 71 },
    { value: 2000, fee: 89 },
    { value: 3000, fee: 108 },
    { value: 4000, fee: 127 },
    { value: 5000, fee: 146 },
    { value: 6000, fee: 165 },
    { value: 7000, fee: 184 },
    { value: 8000, fee: 203 },
    { value: 9000, fee: 222 },
    { value: 10000, fee: 241 },
    { value: 13000, fee: 267 },
    { value: 16000, fee: 293 },
    { value: 19000, fee: 319 },
    { value: 22000, fee: 345 },
    { value: 25000, fee: 371 },
    { value: 30000, fee: 406 },
    { value: 35000, fee: 441 },
    { value: 40000, fee: 476 },
    { value: 45000, fee: 511 },
    { value: 50000, fee: 546 },
    { value: 65000, fee: 666 },
    { value: 80000, fee: 786 },
    { value: 95000, fee: 906 },
    { value: 110000, fee: 1026 },
    { value: 125000, fee: 1146 },
    { value: 140000, fee: 1266 },
    { value: 155000, fee: 1386 },
    { value: 170000, fee: 1506 },
    { value: 185000, fee: 1626 },
    { value: 200000, fee: 1746 },
    { value: 230000, fee: 1925 },
    { value: 260000, fee: 2104 },
    { value: 290000, fee: 2283 },
    { value: 320000, fee: 2462 },
    { value: 350000, fee: 2641 },
    { value: 380000, fee: 2820 },
    { value: 410000, fee: 2999 },
    { value: 440000, fee: 3178 },
    { value: 470000, fee: 3357 },
    { value: 500000, fee: 3536 },
  ];

  static getFeeByValue(valueInDispute: number, quantifier = 1.0, addVAT = false) {
    return this.getFeeRow(this.rvgFees, valueInDispute) * quantifier * (addVAT ? VAT_MULTIPLIER : 1);
  }

  static getFeeRow(fees: (typeof this.rvgFees | typeof this.gkgFees), valueInDispute: number) {
    let result = _head(
      fees.filter((o) => {
        return valueInDispute <= o.value;
      })
    );

    if (result === undefined) {
      return 0;
    }

    return result.fee;
  }

  static getCourtCosts(valueInDispute: number, quantifier = 2) {
    return this.getFeeRow(this.gkgFees, valueInDispute) * quantifier;
  }

  static getExpenses(addVAT = false) {
    return 20 * (addVAT ? VAT_MULTIPLIER : 1);
  }
}

export default FeesService;
